// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"styles_infoCard__13ZwI","bordered":"styles_bordered__123gN","label":"styles_label__1vlg2","entry":"styles_entry__3YJ14","flatten":"styles_flatten__MDY-K"};